import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import './sec-event.css'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic34 from '../assets/pic34.png'
import pic28 from '../assets/pic28.png'
import { supabase } from '../supabase';
import './sec-event-content-mangement.css'
import Contentmangementnav from '../component/common/contentnav';
import Input from '../component/common/input';
import './sec-about.css'
import './sec-support.css'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic35 from '../assets/pic35.png'
import pic32 from '../assets/pic32.png'
import Circlecta from '../component/common/circlectsa.jsx';
import AddCTA from '../component/common/addcta.jsx';
import CTA from '../component/common/cta.jsx';


const About = () => {


const [aboutData, setAboutData] = useState([]);
const [aboutPara, setAboutPara] = useState(null);

const [search, setSearch] = useState('');

const [showForm, setShowForm] = useState(false);
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [filter, setFilter] = useState('');
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

const [formData, setFormData] = useState({
  title: '',
  title_ar: '',
  sentence: '',
  sentence_ar: '',
  image: '',
  show: true
});

const [isEditingPara, setIsEditingPara] = useState(false);
const [paraForm, setParaForm] = useState({
  paragraph: '',
  paragraph_ar: ''
});



useEffect(() => {
 const fetchData = async () => {

    const { data: aboutRes } = await supabase
      .from('About')
      .select('*');

    const { data: paraRes } = await supabase
      .from('About_para')
      .select('*')
      .single();

    setAboutData(aboutRes || []);
    setAboutPara(paraRes || null);
  };

  fetchData();
}, []);



const filteredAbout = aboutData.filter((item) => {
  const matchesSearch =
    item.title?.toLowerCase().includes(search.toLowerCase()) ||
    item.title_ar?.toLowerCase().includes(search.toLowerCase());

  let matchesFilter = true;

  if (filter === 'shown') {
    matchesFilter = item.show === true;
  }

  if (filter === 'hidden') {
    matchesFilter = item.show === false;
  }

  return matchesSearch && matchesFilter;
});









const createAbout = async () => {
  const { error } = await supabase
    .from('About')
    .insert([formData]);

  if (error) {
    console.log(error);
    return;
  }

  const { data } = await supabase.from('About').select('*');
  setAboutData(data);
  handleClose();
};



const handleEditClick = (item) => {
  setFormData({
    title: item.title,
    title_ar: item.title_ar,
    sentence: item.sentence,
    sentence_ar: item.sentence_ar,
    image: item.image,
    show: item.show
  });

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};



const updateAbout = async () => {
  const { error } = await supabase
    .from('About')
    .update(formData)
    .eq('id', editingId);

  if (error) {
    console.log(error);
    return;
  }

  const { data } = await supabase.from('About').select('*');
  setAboutData(data);
  handleClose();
};








const confirmDelete = async () => {
  await supabase.from('About').delete().eq('id', selectedDeleteId);

  setAboutData(prev => prev.filter(item => item.id !== selectedDeleteId));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};



const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);

  setFormData({
    title: '',
    title_ar: '',
    sentence: '',
    sentence_ar: '',
    image: '',
    show: true
  });
};


 return (


        
<section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Landing Page Content"  
                            para="Manage featured events, FAQs, and testimonials"
                            />
                     
                        
                        </article>




                    {showDeleteModal && (
                    <section className="delete-modal-overlay">
                        <article className="delete-modal" role="dialog" aria-modal="true">
                        
                        <header className="delete-modal-header">
                            <div className="delete-icon-wrapper">
                            <img src={pic35} alt='icon'></img>
                            </div>

                            <div className="delete-text-container">
                            <h2 className="delete-title">Delete section</h2>
                            <p className="delete-description">
                                Are you sure you want to delete this section? This action cannot be undone.
                            </p>
                            </div>
                        </header>

                        <nav className="delete-modal-actions">
                            <button
                            className="delete-btn-cancel"
                            onClick={() => {
                                setShowDeleteModal(false);
                                setSelectedDeleteId(null);
                            }}
                            >
                            Cancel
                            </button>

                            <button
                            className="delete-btn-confirm"
                            onClick={confirmDelete}
                            >
                            Delete
                            </button>
                        </nav>

                        </article>
                    </section>
                    )}




                                        {showForm && (
                                        <div className="overlay-create">
                                            <div className="container-create">

                                            <div className="header-create">
                                                <h1 className="title-create">
                                                {isEditing ? 'Edit About Section' : 'Add About Section'}
                                                </h1>

                                                <button
                                                className="close-btn-create"
                                                onClick={handleClose}
                                                type="button"
                                                >
                                                <img src={pic34} alt='close' />
                                                </button>
                                            </div>

                                         <form
                                                className="form-create"
                                                onSubmit={(e) => {
                                                e.preventDefault();
                                                isEditing ? updateAbout() : createAbout();
                                                }}
                                            >

                                                <fieldset className="field-group-create">
                                                <Input
                                                    title="Title"
                                                    placeholder="Enter title"
                                                    type="text"
                                                    value={formData.title}
                                                    onChange={(e) =>
                                                    setFormData({ ...formData, title: e.target.value })
                                                    }
                                                />
                                                </fieldset>

                                                <fieldset className="field-group-create">
                                                    <Input
                                                        title="Title (Arabic)"
                                                        placeholder="Enter Arabic title"
                                                        type="text"
                                                        value={formData.title_ar}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, title_ar: e.target.value })
                                                        }
                                                    />
                                                </fieldset>

                                                <fieldset className="container-text-area">
                                                    <h2 className="title-text-area">Sentence</h2>
                                                    <textarea
                                                        className="main-text-area"
                                                        placeholder="Enter sentence"
                                                        value={formData.sentence}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, sentence: e.target.value })
                                                        }
                                                    />
                                                </fieldset>

                                                <fieldset className="container-text-area">
                                                    <h2 className="title-text-area">Sentence (Arabic)</h2>
                                                    <textarea
                                                        className="main-text-area"
                                                        placeholder="Enter Arabic sentence"
                                                        value={formData.sentence_ar}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, sentence_ar: e.target.value })
                                                        }
                                                    />
                                                </fieldset>

                                                <fieldset className="field-group-create">
                                                <fieldset className='container-text-area'>
                                                    <h2 className="title-text-area">Image URL</h2>

                                                    <input
                                                    type="text"
                                                    placeholder="Paste image URL"
                                                    value={formData.image}
                                                    onChange={(e) =>
                                                        setFormData({ ...formData, image: e.target.value })
                                                    }
                                                    className="input-search2"
                                                    />

                                                    {formData.image && (
                                                    <img
                                                        src={formData.image}
                                                        alt="preview"
                                                        className="preview-image-create"
                                                    />
                                                    )}
                                                </fieldset>
                                                </fieldset>

                                                <fieldset className="fieldset">
                                                <label className='title-input'>Show Section</label>

                                                <div className="select-wrapper2">
                                                    <img src={pic28} className="arrow-icon2" alt="arrow" />

                                                    <select
                                                    className="input-search2 select-style2"
                                                    value={formData.show ? "true" : "false"}
                                                    onChange={(e) =>
                                                        setFormData({
                                                        ...formData,
                                                        show: e.target.value === "true"
                                                        })
                                                    }
                                                    >
                                                    <option value="true">Show</option>
                                                    <option value="false">Hide</option>
                                                    </select>
                                                </div>
                                                </fieldset>

                                                <nav className='container-ctas-craete'>
                                                <button
                                                    type="button"
                                                    className="cta-cancel-create"
                                                    onClick={handleClose}
                                                >
                                                    <h2 className="cta-cancel-text-create">Cancel</h2>
                                                </button>

                                                <button type="submit" className='cta-create'>
                                                    <h2 className='cta-create-text'>
                                                    {isEditing ? 'Edit Section' : 'Add Section'}
                                                    </h2>
                                                </button>
                                                </nav>

                                            </form>
                                            </div>
                                        </div>
                                        )}




                                            {isEditingPara && (
                                            <div className="overlay-create">
                                                <div className="container-create">

                                                <div className="header-create">
                                                    <h1 className="title-create">Edit Paragraph</h1>

                                                    <button
                                                    className="close-btn-create"
                                                    onClick={() => setIsEditingPara(false)}
                                                    type="button"
                                                    >
                                                    <img src={pic34} alt="close" />
                                                    </button>
                                                </div>

                                                <div className="form-create">

                                                        <fieldset className="container-text-area">
                                                        <h2 className="title-text-area">Paragraph</h2>
                                                        <textarea
                                                            className="main-text-area"
                                                            value={paraForm.paragraph}
                                                            onChange={(e) =>
                                                            setParaForm({ ...paraForm, paragraph: e.target.value })}/>
                                                        </fieldset>

                                                    <fieldset className="container-text-area">
                                                    <h2 className="title-text-area">Paragraph (Arabic)</h2>
                                                    <textarea
                                                        className="main-text-area"
                                                        value={paraForm.paragraph_ar}
                                                        onChange={(e) =>
                                                        setParaForm({ ...paraForm, paragraph_ar: e.target.value })
                                                        }/>
                                                    </fieldset>

                                                    <nav className='container-ctas-craete'>
                                                    <button
                                                        className="cta-cancel-create"
                                                        onClick={() => setIsEditingPara(false)}>
                                                        <h2 className="cta-cancel-text-create">Cancel</h2>
                                                    </button>

                                                    <button
                                                        className="cta-create"
                                                        onClick={async () => {
                                                        const { error } = await supabase
                                                            .from('About_para')
                                                            .update(paraForm)
                                                            .eq('id', aboutPara.id);

                                                        if (!error) {
                                                            setAboutPara({ ...aboutPara, ...paraForm });
                                                            setIsEditingPara(false);
                                                        }}}>
                                                        <h2 className="cta-create-text">Save</h2>
                                                    </button>
                                                    </nav>

                                                </div>
                                                </div>
                                            </div>
                                            )}

<section className='container-table-and-section'>


                        <Contentmangementnav />



                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper-about">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />

                                <Circlecta  onClick={() => setShowForm(true)}/>

                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                        <option value="shown">Shown</option>
                                        <option value="hidden">Hidden</option>
                                </select>
                                </div>


                            </fieldset>



                                                 <div className="table-container" >

                                {aboutPara && (
                                    <div className="para-container-about">

                                        <article className='CONTAINER-SUB-PARA'>
                                        <p className='sentfrom-support'>{aboutPara.paragraph}</p>
                                        <p className="sentfrom-support-ar">{aboutPara.paragraph_ar}</p>
                                        </article>

                                        <button
                                        className='cta-about'
                                        onClick={() => {
                                            setIsEditingPara(true);
                                            setParaForm({
                                            paragraph: aboutPara.paragraph,
                                            paragraph_ar: aboutPara.paragraph_ar
                                            });
                                        }}
                                        >
                                            <h2 className='cta-text'>Edit</h2>
                                     
                                        </button>

                                    </div>
                                    )}



                                 <table className='table-table-concert-mangem'>
                                                                   
{filteredAbout.map((item) => (
                                <tbody key={item.id}>
                                    <tr className="row-table2-contenttt">

                                    <div className="container-table-info-about-sec">

                                       
                                        <div className='main-info'>
                                            <article className='row-aboutt'>
                                                <article className='main-info'>
                                                        <img src={item.image} className="icon-about" />

                                                        <h2 className="header-support">{item.title}</h2>
                                                        <p className="sentfrom-support">{item.sentence}</p>
                                                </article>
                                                
                                                <nav className='right-box-about'> 
                                                <label className="custom-checkboxl">
                                                    <input
                                                    type="checkbox"
                                                    checked={item.show}
                                                    onChange={async () => {
                                                        const newValue = !item.show;

                                                        await supabase
                                                        .from('About')
                                                        .update({ show: newValue })
                                                        .eq('id', item.id);

                                                        setAboutData(prev =>
                                                        prev.map(el =>
                                                            el.id === item.id ? { ...el, show: newValue } : el
                                                        )
                                                        );
                                                    }}
                                                    />
                                                    <span className="checkmarkcontent"></span>
                                                    <h3 className="SHOW">Show on homepage</h3>
                                                </label>


                                                <nav className='cta-table'>
                                                    <button className='cta2-table'>
                                                        <img src={pic30} alt='hide'></img>
                                                    </button>
                                                    <button
                                                    className='cta2-table'
                                                    onClick={() => handleEditClick(item)}
                                                    >
                                                    <img src={pic31} alt='edit' />
                                                    </button>
                                                    <button
                                                    className='cta2-table'
                                                    onClick={() => {
                                                    setSelectedDeleteId(item.id);
                                                    setShowDeleteModal(true);
                                                            }}
                                                        >
                                                        <img src={pic32} alt='delete' />
                                                        </button>
                                                                                                            
                                                </nav>



                                                </nav>

                                            </article>



                                        <div className='line-supporttt'></div>
                                        <h3 className="header-support-ar">{item.title_ar}</h3>
                                        <p className="sentfrom-support-ar">{item.sentence_ar}</p>
                                        </div>

                                    </div>


                                    </tr>
                                </tbody>



                         ))}
                           </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
            </section>
        </section>
    );
}
 
export default About;